import React from 'react';

import type {
  FixedPrizeDrawLostMPNotification,
  FixedPrizeDrawWonMPNotification
} from '@swf/core/types/Notification';

import type { CardViewProps } from '../../config/NotificationTypes';
import CardBackTemplate from '../CardBack/Template';
import CardDescription, { Variant as DescriptionVariant } from '../CardDescription/CardDescription';
import PaginatedData from '../PaginatedData/PaginatedData';

import { TXTWCL_N0_prizes_awarded_to_N1_winner_ELL } from './FixedPrizeDrawBack.messages.json';

type Props = CardViewProps & {
  cardData: FixedPrizeDrawWonMPNotification | FixedPrizeDrawLostMPNotification;
};

const pageSize = 10;

const FixedPrizeDrawBack: React.FC<Props> = (props) => {
  const { attributes } = props.cardData;
  return (
    <CardBackTemplate {...props}>
      <CardDescription
        variant={DescriptionVariant.Heading}
        attributes={attributes}
        descriptionKey={{
          tag: TXTWCL_N0_prizes_awarded_to_N1_winner_ELL,
          values: { 0: 'numPrizes', 1: 'numWinners' }
        }}
      />
      {attributes.winners && (
        <PaginatedData
          pageSize={pageSize}
          dataSet={attributes.winners}
          columnKeys={['prizeTitle', 'playerId']}
        />
      )}
    </CardBackTemplate>
  );
};

export default FixedPrizeDrawBack;
